import { FC, useState } from 'react';
import FleetModal from '@/libs/antd/components/Modal';
import FleetTitle from '@/libs/antd/components/Title';
import { CustomerCompanyManagementInformationForm } from '@/pages/frm/customer-v2/CustomerPage';
import ManagerForm, { useManagerForm } from '../forms/ManagerForm';

type ManagerData = CustomerCompanyManagementInformationForm & {
	index?: number;
};

type ModalData =
	| { type: 'new' }
	| {
			type: 'edit';
			data: ManagerData;
	  };

export const useManagerModal = (
	onSubmit: (type: ModalData['type'], data: ManagerData) => void,
) => {
	const [modalData, setModalData] = useState<ModalData>();

	return {
		data: modalData,
		isOpen: Boolean(modalData),
		open: (data: ModalData) => setModalData(data),
		close: () => setModalData(undefined),
		onSubmit,
	};
};

const ManagerModal: FC<ReturnType<typeof useManagerModal>> = (props) => {
	const managerForm = useManagerForm((values) => {
		props.close();
		props.onSubmit(props.data!.type, {
			...values,
			index: props.data?.type === 'edit' ? props.data.data.index : undefined,
		});
	});

	const { form } = managerForm;

	return (
		<FleetModal
			open={props.isOpen}
			width={940}
			closable={false}
			buttonPosition="end"
			okText="SAVE"
			cancelText="BACK"
			onCancel={() => props.close()}
			onOk={form.submit}
			afterOpenChange={(isOpen) => {
				if (!isOpen) {
					form.resetFields();
				} else if (props.data?.type === 'edit') {
					form.setFieldsValue(props.data.data);
				}
			}}
		>
			<FleetTitle>Tambah Pengurus</FleetTitle>
			<ManagerForm {...managerForm} />
		</FleetModal>
	);
};

export default ManagerModal;
